import { BillingMode } from '../../../../services/exports/Constants';

export default {
  billing_modes: {
    [BillingMode.Stripe]: 'Metodă de plată',
    [BillingMode.InternalInvoicing]: 'Plăți',
  },
};
